const Request = require('./BaseRequest')
const PromoGraph = require('../graph/PromoGraph')

module.exports = class PromoRequest extends Request
{
    constructor(apiDomain)
    {
        super(apiDomain)
        this.graph = new PromoGraph(this.apiDomain)
    }

    swrPromo(location)
    {
        let args = {location: location}
        let { type, query } = this.graph.promoQuery([
            'id', 'title', 'description', 'image', 'sales_page_url', 'start_date', 'end_date', 'misc_data', 'is_active'
        ], args)
        
        return this.graph.swrRequest(query, this.swrOptions, type)
    }

}